import { Badge, Button, Stack, styled } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import DescriptionIcon from '@mui/icons-material/Description';
import { Search } from '../../../../../../../shared/components/table/components/search.component';
import { useTranslation } from 'react-i18next';
import { articleOverviewState } from '../articlesOverview.state.tsx';
import { Theme as theme } from '../../../../../../../shared/styles/theme/theme';

export const SideControls: FC<ISideControlsProps> = ({ isActive, onExportDocument }) => {
  const { t } = useTranslation();
  const [isShowSaveButton, setIsShowSaveButton] = useState<boolean>(false);
  const [saving, setSaving] = useState<boolean>(false);
  useEffect(() => {
    const saveButtonSub = articleOverviewState.sub.showSaveButton().subscribe(setIsShowSaveButton);
    const savingSub = articleOverviewState.sub.saveLoading().subscribe(setSaving);
    return () => {
      saveButtonSub.unsubscribe();
      savingSub.unsubscribe();
    };
  }, []);

  const badgeComp = isActive && <SBadge variant='dot' color='primary' />;

  return (
    <Stack
      sx={{
        marginBottom: '16px',
        gap: 2,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Stack
        sx={{
          flexDirection: 'row',
          gap: 2,
          flexGrow: 1,
        }}
      >
        <Search
          sx={{ maxWidth: '400px', marginBottom: 0 }}
          onSearch={(v) => articleOverviewState.pub.search(v)}
        />
        <Button
          variant='outlined'
          color='secondary'
          startIcon={<AutoAwesomeMotionIcon sx={{ fill: 'rgba(0, 0, 0, 0.54)' }} />}
          sx={{
            height: '42px',
            backgroundColor: isActive ? theme.palette.grey['200'] : 'inherit',
            color: theme.palette.black.main,
            fontSize: '15px',
          }}
          onClick={() => articleOverviewState.pub.toggleGroupMode()}
        >
          {t('common.grouping')}
          {badgeComp}
        </Button>
        <Button
          variant='outlined'
          color='secondary'
          startIcon={<DescriptionIcon sx={{ fill: theme.palette.text.secondary }} />}
          sx={{
            height: '42px',
            color: theme.palette.black.main,
            fontSize: '15px',
          }}
          onClick={onExportDocument}
        >
          {t('common.export')}
        </Button>
      </Stack>
      {isShowSaveButton && (
        <Button
          disabled={saving}
          variant='contained'
          sx={{ minWidth: 150 }}
          onClick={() => articleOverviewState.pub.saveData()}
        >
          {t('common.save')}
        </Button>
      )}
    </Stack>
  );
};

const SBadge = styled(Badge)(() => ({
  position: 'absolute',
  top: 14,
  left: 28,
}));

interface ISideControlsProps {
  isActive: boolean;
  onExportDocument: () => void;
}
